<template>
  <div class="activity-logs">
    <h3>User Multiple Activity Logs: {{ positionsData.length }}</h3>

    <el-alert
      title="Expand row to view activity from different account logins"
      type="info"
      show-icon
    />

    <el-table
      :data="positionsData"
      border
      stripe
      highlight-current-row
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table
            :data="props.row.parsed"
            border
          >
            <el-table-column
              prop="first_name"
              label="First Name"
            />
            <el-table-column
              prop="last_name"
              label="Last Name"
            />
            <el-table-column
              prop="email"
              label="Email"
            />
            <el-table-column
              prop="lastLogin"
              label="Last Login"
            >
              <template slot-scope="scope">
                {{ displayDateTime(scope.row.lastLogin) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="profile_id"
              label="Account Type"
            >
              <template slot-scope="scope">
                <span :class="accountType(scope.row.profile_id)">{{ accountType(scope.row.profile_id) | ucfirst }}</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>

      <el-table-column
        prop="first_name"
        label="First Name"
      >
        <template slot-scope="scope">
          {{ scope.row.first_name | NA }}
        </template>
      </el-table-column>
      <el-table-column
        prop="last_name"
        label="Last Name"
      >
        <template slot-scope="scope">
          {{ scope.row.last_name | NA }}
        </template>
      </el-table-column>
      <el-table-column
        prop="email"
        label="Email"
      />
      <el-table-column
        prop="created_date"
        label="Last Login"
      >
        <template slot-scope="scope">
          {{ displayDateTime(scope.row.created_date) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="profile_id"
        label="Account Type"
      >
        <template slot-scope="scope">
          <span :class="accountType(scope.row.profile_id)">{{ accountType(scope.row.profile_id) | ucfirst }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from '@/axios/axios'

export default {
  name: 'Activity',
  data() {
    return {
      positionsData: []
    }
  },
  async created() {
    await this.getUserActivity()
  },
  methods: {
    getUserActivity() {
      const proxyURL = process.env.VUE_APP_PROXY

      return axios.get(`${proxyURL}activity`)
        .then(res => {
          this.positionsData = res.data
        })
        .catch(axios.handleError)
    },

    accountType(profileID) {
      return profileID ? 'recruiter' : 'candidate'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~vars";

  .recruiter {
    font-weight: 700;
    color: $-color-warning;
  }

  .candidate { color: $-color-success; }
</style>

<style lang="scss">
  @import "~vars";

  .activity-logs {
    .el-table__row.expanded {
      font-weight: 700;
    }

    .el-table__expanded-cell {
      background-color: $-color-body;
    }
  }
</style>
